export default "__VITE_ASSET__BLfk67MP__"